import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input } from 'semantic-ui-react';
import api from '../../../api';
import Erro from '../../layouts/mensagens/Erro';
import SenhaInput from '../../layouts/SenhaInput';
import * as FormValidator from '../../../utils/formValidator';
import { salvarIntegracao, desativarIntegracao } from '../../../actions/usuario';
import { ALMAH } from '../../../models/enums/tipoIntegracao';
import Integracao from './Integracao';

const VAZIO = { ativo: false, pendente: false, loading: false, dados: { clientId: '', clientSecret: '' }, errors: {} };

const IntegracaoAlmah = () => {
  const dispatch = useDispatch();
  const [form, setForm] = useState({ ...VAZIO, loading: true });

  useEffect(() => {
    api.usuario.findIntegracoes().then(res => {
      const almah = res && res.integracoes && res.integracoes.find(it => it.tipo === ALMAH.value);
      if (almah && almah.ativo) {
        setForm({ ...VAZIO, ativo: true, dados: almah.dados });
      } else {
        setForm(p => ({ ...p, loading: false }));
      }
    }).catch(() => setForm(p => ({ ...p, loading: false })));
  }, []);

  const onClick = async () => {
    if (form.ativo) {
      setForm(p => ({ ...p, loading: true }));
      dispatch(desativarIntegracao({ tipo: ALMAH.value })).then(() => setForm(VAZIO));
    } else if (form.pendente) {
      const errors = {};
      if (FormValidator.isVazio(form.dados.clientId)) errors.clientId = 'Client ID obrigatório';
      if (FormValidator.isVazio(form.dados.clientSecret)) errors.clientSecret = 'Token de acesso obrigatório';

      if (Object.keys(errors).length > 0) {
        setForm(p => ({ ...p, errors }));
      } else {
        setForm(p => ({ ...p, loading: true }));
        dispatch(salvarIntegracao({ tipo: ALMAH.value, dados: form.dados }))
          .then(() => setForm({ ...VAZIO, ativo: true, dados: form.dados }))
          .catch(e => setForm(p => ({
            ...p,
            loading: false,
            errors: { geral: (e && e.data && e.data.error) || 'Não foi possível salvar a integração.' },
          })));
      }
    } else {
      setForm(p => ({ ...p, pendente: true }));
    }
  };

  const onChange = e => {
    const { name, value } = e.target;
    setForm(p => ({ ...p, dados: { ...p.dados, [name]: value }, errors: {} }));
  };

  return (
    <Integracao
      label="Almah Condos"
      description={<>Verifica a adimplência dos proprietários no <i>Almah Condos</i> e bloqueia a votação de unidades com débito vencido. O condomínio é localizado pelo CNPJ cadastrado.</>}
      ativo={form.ativo}
      pendente={form.pendente}
      onClick={onClick}
      onCancel={() => setForm(p => ({ ...p, pendente: false }))}
    >
      {(form.ativo || form.pendente) && (
        <Form loading={form.loading} style={{ marginTop: 20 }}>
          <Form.Group widths="equal">
            <Form.Field error={!!form.errors.clientId} required>
              <label htmlFor="almahClientId">Client ID</label>
              <Input
                id="almahClientId"
                name="clientId"
                placeholder="Client ID"
                autoComplete="off"
                onChange={onChange}
                value={form.dados.clientId}
                disabled={form.ativo}
              />
              <Erro text={form.errors.clientId} />
            </Form.Field>
            <Form.Field error={!!form.errors.clientSecret} required>
              <label htmlFor="almahClientSecret">Token de acesso</label>
              <SenhaInput
                id="almahClientSecret"
                name="clientSecret"
                placeholder="Token de acesso"
                autoComplete="off"
                onChange={onChange}
                value={form.dados.clientSecret}
                disabled={form.ativo}
              />
              <Erro text={form.errors.clientSecret} />
            </Form.Field>
          </Form.Group>
          <Erro text={form.errors.geral} />
        </Form>
      )}

    </Integracao>
  );
};

export default IntegracaoAlmah;
